import { data } from '../../svg/Close/data';
import { makeIcon } from '../makeIcon';

export const Close = makeIcon(data, 'close', 'Close');

export default Close;
